export default {
  addNote: null,
  notesList: null,
  latestNotes: null,
}